import type { ProjectRepository } from '@/domain/project/ProjectRepository'
import { logout } from '@/application/auth/api'
import { BACKEND_ENABLED } from '@/infrastructure/config/featureFlags'

/**
 * PRD #8 + tech-spec §12.4: clears every locally-stored byte AND
 * the server-side session cookie.
 *
 * Order matters:
 *   1. POST /v1/auth/logout — best-effort. Even if it fails (network
 *      down, backend not deployed yet), we proceed; the cookie is
 *      session-bound to the JWT which expires in 24h regardless.
 *   2. Delete the IndexedDB database via the repo's `wipeAll`.
 *   3. Clear localStorage (theme + locale + future flags).
 *
 * Caller is responsible for routing the user back to `/` after the
 * promise resolves.
 */
export async function wipeAllLocalData(repo: ProjectRepository): Promise<void> {
  if (BACKEND_ENABLED) await logout()
  await repo.wipeAll()
  if (typeof localStorage !== 'undefined') {
    localStorage.clear()
  }
}
